<div class="img-magnifier-container">
  <!-- Use imageUrl to dynamically set the src attribute of the image -->
  <img #imageElement id="myimage" [src]="imageUrl" width="600" height="400">
</div>
<div #magnifierGlass></div>